<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>
            Add payment
            <p *ngIf="refund" class="subtitle">Refund #{{refund.number}}</p>
        </ion-title>
        <ion-buttons *ngIf="online && !loading" slot="end">
            <ion-button (click)="add()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="online && !loading && refund" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Close" interface="alert" label="Method" labelPlacement="stacked" fill="outline" [(ngModel)]="params.method" (ionChange)="methodChanged()">
                                <ion-select-option *ngIf="smartpay_connected || has_stripe_payments" value="credit_card">Card</ion-select-option>
                                <ion-select-option value="bank_transfer">Bank transfer</ion-select-option>
                                <ion-select-option value="cash">Cash</ion-select-option>
                                <ion-select-option *ngIf="!smartpay_connected" value="external_card">External card</ion-select-option>
                                <ion-select-option *ngIf="this.order.person && !this.order.organisation" value="person_store_credit">Person store credit</ion-select-option>
                                <ion-select-option *ngIf="this.order.organisation" value="organisation_store_credit">Organisation store credit</ion-select-option>
                                <ion-select-option *ngIf="custom_payment_services && custom_payment_services.length > 0" value="custom">Custom</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'custom'">
                        <ion-col>
                            <ion-select cancelText="Close" interface="alert" label="Payment service" labelPlacement="stacked" fill="outline" [(ngModel)]="params.payment_service_id">
                                <ng-container *ngFor="let custom_payment_service of custom_payment_services">
                                    <ion-select-option *ngIf="custom_payment_service.status == 'active'" value="{{custom_payment_service.id}}">{{custom_payment_service.name}}</ion-select-option>
                                </ng-container>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'custom'">
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params.payment_service_transaction_id">
                                <div slot="label">Payment service transaction ID<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="credit_card_payments.length != 0 && stripe_connected && params.method == 'credit_card'">
                        <ion-col>
                            <ion-select cancelText="Close" interface="alert" label="Payment" labelPlacement="stacked" fill="outline" [(ngModel)]="params.originating_payment_id" (ionChange)="originatingPaymentChanged()">
                                <ion-select-option *ngFor="let payment of credit_card_payments" value="{{payment.id}}">{{payment.payment_service.name}} ({{payment.price | currency:order.currency.code:'symbol-narrow':'1.2-2'}})</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="tel" inputmode="decimal" maxlength="10" label="Amount" labelPlacement="stacked" fill="outline" [(ngModel)]="params.price"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row >
                        <ion-col>
                            <ion-input *ngIf="params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                            <ion-input *ngIf="!params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="xero_connected && refund.xero_credit_note_id">
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="params['add_xero_credit_note_payment']">Add payment to Xero credit note</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>